<template>
  <el-tooltip :content="title" placement="bottom-start" effect="light" :enterable="false" popper-class="title-style"
    :open-delay="400">
   <slot></slot>
  </el-tooltip>
</template>

<script>
  export default {
    props: ["title"],
    methods: {
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/tooltip.vue